var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "rb-crosslink",
      class:
        ((_obj = {
          "rb-crosslink--active": _vm.isActive,
          "rb-crosslink--skeleton": _vm.hasSkeleton || _vm.loading,
          "rb-crosslink--with-image": _vm.image,
        }),
        (_obj["rb-crosslink--" + _vm.color] = _vm.color),
        _obj),
      attrs: { href: _vm.href, "data-mnt-header-link": _vm.label },
    },
    [
      _vm.image
        ? _c("rb-lazy-media", {
            staticClass: "rb-crosslink__image",
            class: {
              "rb-crosslink__image--skeleton": _vm.hasSkeleton || _vm.loading,
            },
            attrs: { src: _vm.image, alt: _vm.label },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("span", { staticClass: "rb-crosslink__label" }, [
        _vm._v(_vm._s(_vm.label)),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }